import { useState,useEffect } from "react"
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom"
import {
    Button, Card, CardBody, Col, Container, Row, Modal, ModalBody, TabContent,
    TabPane, Nav, NavItem, NavLink, Table, FormGroup, Input, Label
} from "reactstrap";
import BreadCrumb from "../Common/BreadCrumb";
import { Loader } from "../Utils/Loader";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { tabChange } from "../Utils/SetDefaultRowData";
import classnames from "classnames";
import { combineUserAndAdminPermissions } from "./Constant/combineUserAndAdminPermissions";
import { CRUD_PERMS } from "./Constant/constants";
import { formatSubmoduleName,camelCaseToTitle } from "./Constant/common";
import {userColoumns} from "../UserManagement/Constant/UserManagementColoumn";
import { MaterialReactTable } from "material-react-table";
import { useDispatch } from "react-redux";
import { getAllUser } from "../../slices/UserManagement/thunk";
import { userRoleMap,DefaultRole } from "./Constant/constants";
export const ViewUserRole = () => {
    const [loading, setLoading] = useState()
    const [activeTab, setActiveTab] = useState("1");
    const location = useLocation()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const columns = userColoumns()
    const operatorId = localStorage.getItem('operatorId');
    const { userRole: selectedRow, totalModules } = location?.state || {};
    const [openSubmodulePopover, setOpenSubmodulePopover] = useState(null);
    const user = useSelector((state) => state?.GetAllUser?.getAllUser)
    const currentRoleUsers=user.filter(u=>u.role===selectedRow?.rolename)

    const data=currentRoleUsers.map((user)=>({
        userId:user?.userDetails?.userId,
        userName: user?.userDetails?.userName,
        email:user?.email,
        fullName:user?.profile?.firstName + " " + user?.profile?.lastName,
        phone: user?.userDetails?.dialCode + " " + user?.userDetails?.phone,
        role:selectedRow?.roletype.toLowerCase()===DefaultRole ?userRoleMap.get(user?.role):user?.role,
        status:user?.status
    }))

    const userPermissions = selectedRow?.modules
    const permissions = useSelector(
        (state) => state.permissions.permissions
    );

    const operatorConfiguration = useSelector((state) => state?.GetOperatorSpecificConfiguration?.OperatorSpecificConfiguration)
    const isEIPEnabled = operatorConfiguration?.configurations?.EIP?.value?.Enabled?.value === true;
    const roleName=localStorage.getItem("roleName");

    const labelText = isEIPEnabled
        ? ((roleName === "telcoAdmin" || roleName === "telcoOperationUser" || roleName === "telcoBusinessUser") ? "Device Search" : "Device List")
        : ((roleName === "telcoAdmin" || roleName === "telcoOperationUser" || roleName === "telcoBusinessUser") ? "Customer Search" : "Customer List");

    const rawPermissions = useSelector(
        (state) => state.permissions.permissionsMap
    );

    const permissionsMap = new Map(
        rawPermissions.map(([key, value]) => [key, new Set(value)])
    );
    const mergeSelectedAndAdminPermissions = combineUserAndAdminPermissions(userPermissions, permissions?.modules)
    const roleSummary = {
        "User Role Name": selectedRow?.roletype.toLowerCase()===DefaultRole ?userRoleMap.get(selectedRow?.rolename):selectedRow?.rolename,
        "Type": selectedRow?.roletype.toLowerCase()===DefaultRole ? "Default" : "Custom",
        "Module Access": `${selectedRow?.modules.filter(module=>module?.module.toLowerCase()!="miscellaneous").length}/${totalModules}`,
        "Number of Users": data.length,
    }

      useEffect(() => {
            dispatch(getAllUser(setLoading, operatorId));
        }, [dispatch]);

    return <div id='csms' className='page-content bg-white'>
        <Container fluid>
            <BreadCrumb title={"User Roles"} />
            <ToastContainer position='top-center' />
            <Row>
                <Col lg={12}>
                        <div className="mb-3 mt-1 table-responsive">
                            {loading && (<Loader />)}
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h1 className="fs-18 fw-semibold text-black">View Role</h1>
                               {roleSummary?.Type !== 'Default' && <Button
                                    color="primary"
                                    onClick={() =>
                                        navigate(`/edit-userrole/${selectedRow?.rolename}`, {
                                            state: { userRole: selectedRow },
                                        })
                                    }
                                >
                                    <i className="bx bxs-edit me-2"></i> Edit
                                </Button>}

                            </div>
                            <Row className="my-3">
                                {roleSummary && Object.keys(roleSummary).map((key) => (
                                    <Col lg={3} md={4} sm={6} xs={12} className="mb-3" key={key}>
                                        <h5 className="fs-14 fw-semibold text-black">{key}</h5>
                                        <p className="fs-14">{roleSummary[key] ?? 0}</p>
                                    </Col>
                                ))}
                            </Row>
                            <Nav className="nav-tabs-custom card-header-tabs mb-4 " role="tablist">
                                <NavItem>
                                    <NavLink
                                        className={classnames({ active: activeTab === "1" })}
                                        onClick={() => {
                                            tabChange("1", activeTab, setActiveTab);
                                        }}
                                    >
                                        <i className="fas fa-home"></i>
                                        Modules
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        to="#"
                                        className={classnames({ active: activeTab === "2" })}
                                        onClick={() => {
                                            tabChange("2", activeTab, setActiveTab);
                                        }}
                                        type="button"
                                    >
                                        <i className="far fa-envelope"></i>
                                        Users
                                    </NavLink>
                                </NavItem>
                            </Nav>
                            <TabContent activeTab={activeTab}>
                                <TabPane tabId="1">
                                    <div>
                                        <div>
                                            {mergeSelectedAndAdminPermissions.map((mod, mIdx) => {
                                                return (
                                                    <div key={mIdx} className="border border-1 p-2 my-4" style={{ overflowX: 'auto' }}>
                                                        <div className="d-flex justify-content-between">
                                                            <span className="text-black fw-bold fs-16">{mod.module}</span>
                                                        </div>
                                                        <hr></hr>
                                                        <Table borderless responsive={true}
                                                            style={{ tableLayout: 'fixed', minWidth: '700px' }}
                                                        >
                                                            <colgroup>
                                                                <col style={{ width: '30%' }} />
                                                                <col style={{ width: '10%' }} />
                                                                <col style={{ width: '10%' }} />
                                                                <col style={{ width: '10%' }} />
                                                                <col style={{ width: '10%' }} />
                                                                <col style={{ width: '10%' }} />
                                                                <col style={{ width: '10%' }} />
                                                            </colgroup>
                                                            <thead className="border border-0">
                                                                <tr>
                                                                    <th>

                                                                    </th>
                                                                    <th className="text-nowrap">
                                                                        Allow All
                                                                    </th>
                                                                    {CRUD_PERMS.map((perm) => (
                                                                        <th key={perm}>{perm}</th>
                                                                    ))}
                                                                    <th>

                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody className="border border-0">
                                                                {mod?.submodules?.map((sub, sIdx) => {
                                                                    const allSubModulePermissions = [
                                                                        ...(permissionsMap.get(
                                                                            `${mod.module.toLowerCase()}-${sub.submodule.toLowerCase()}`
                                                                        ) || []),
                                                                    ];
                                                                    const otherPermissions = allSubModulePermissions.filter(
                                                                        (p) => !CRUD_PERMS.includes(camelCaseToTitle(p))
                                                                    );
                                                                    const subKey = `${mod.module.toLowerCase()}-${sub.submodule.toLowerCase()}`;
                                                                    return <tr key={sIdx}>
                                                                        <td>
                                                                            <span className="fs-16">{sub.submodule.toLowerCase() === "customer" ? labelText : formatSubmoduleName(sub.submodule)}</span>
                                                                        </td>
                                                                        <td>
                                                                            {
                                                                                sub.permissions.length > 0 &&
                                                                                    [
                                                                                        ...(permissionsMap.get(
                                                                                            `${mod.module.toLowerCase()}-${sub.submodule.toLowerCase()}`
                                                                                        ) || []),
                                                                                    ].every((item) => sub.permissions.includes(item.toLowerCase())) ? <i class="ri-check-fill text-success fs-4"></i> : <i class="ri-subtract-line fs-4"></i>
                                                                            }

                                                                        </td>
                                                                        {CRUD_PERMS.map((perm) => {
                                                                            return <td key={perm}>
                                                                                {sub.permissions.includes(perm.toLowerCase()) ? <i class="ri-check-fill text-success fs-4"></i> : <i class="ri-subtract-line fs-4"></i>}
                                                                            </td>
                                                                        })}
                                                                        <td>
                                                                            {otherPermissions.length > 0 && (
                                                                                <>
                                                                                    <span
                                                                                        style={{ cursor: 'pointer' }}
                                                                                        onClick={() => setOpenSubmodulePopover(subKey)}
                                                                                    >
                                                                                        More Options
                                                                                    </span>

                                                                                    {openSubmodulePopover === subKey && (
                                                                                        <div
                                                                                            style={{
                                                                                                position: 'absolute',
                                                                                                right: "30px",
                                                                                                background: 'white',
                                                                                                border: '1px solid #ccc',
                                                                                                padding: '10px',
                                                                                                zIndex: 100,
                                                                                                display: 'flex',
                                                                                                flexDirection: 'column',
                                                                                                minWidth: '150px',
                                                                                            }}
                                                                                        >
                                                                                            <span
                                                                                                style={{
                                                                                                    position: 'absolute',
                                                                                                    top: '5px',
                                                                                                    right: '5px',
                                                                                                    cursor: 'pointer',
                                                                                                    fontWeight: 'bold',
                                                                                                }}
                                                                                                onClick={() => setOpenSubmodulePopover(null)}
                                                                                            >
                                                                                                X
                                                                                            </span>

                                                                                            {otherPermissions.map((perm) => (
                                                                                                <label
                                                                                                    key={perm}
                                                                                                    style={{
                                                                                                        display: 'flex',
                                                                                                        marginTop: '5px',
                                                                                                        textAlign: 'Start',
                                                                                                        alignItems: 'center',
                                                                                                    }}
                                                                                                >
                                                                                                    {sub.permissions.includes(perm.toLowerCase())
                                                                                                        ? <i class="ri-check-fill text-success fs-4"></i> : <i class="ri-subtract-line fs-4"></i>}
                                                                                                    <span className="mb-0 ps-2">{camelCaseToTitle(perm)}</span>
                                                                                                </label>
                                                                                            ))}
                                                                                        </div>
                                                                                    )}
                                                                                </>
                                                                            )}
                                                                        </td>
                                                                    </tr>

                                                                })}
                                                            </tbody>
                                                        </Table>
                                                    </div>
                                                )

                                            })}
                                        </div>

                                    </div>
                                </TabPane>
                                <TabPane tabId="2">
                                     {user?
                                        <MaterialReactTable
                                            icons={{ DragHandleIcon: () => <i className="ri-drag-move-fill" />, }}
                                            displayColumnDefOptions={{
                                                'mrt-row-actions': {
                                                    header: '',
                                                    enableHiding: true,
                                                    size: 53,
                                                    grow: true
                                                },
                                            }}
                                            muiTableContainerProps={{
                                                sx: {
                                                    border: '1px solid #e9ebec',
                                                }
                                            }}
                                            defaultColumn={{
                                                minSize: 10,
                                                maxSize: 9001,
                                                muiTableBodyCellProps: {
                                                    sx: {
                                                        fontFamily: "Inter,sans-serif"
                                                    }
                                                },
                                                muiTableHeadCellProps: {
                                                    sx: {
                                                        fontFamily: "Inter,sans-serif"
                                                    }
                                                }
                                            }}
                                            layoutMode='grid'
                                            columns={columns}
                                            data={data}
                                            enableColumnActions={true}
                                            enableDensityToggle={false}
                                            enableTopToolbar={false}
                                        />:null}
                                </TabPane>
                            </TabContent>
                        </div>
                </Col>
            </Row>
        </Container>
    </div>
}